<template>
  <div class="date-range-picker flex-wrap d-flex">
    <div class="d-flex align-items-center date-range-picker--date-cell">
      <label class="me-3">От:</label>
      <datepicker
        :value="dateFrom"
        :language="RU"
        :disabled-dates="disabledDatesForFrom"
        :format="format"
        :monday-first="true"
        :clear-button="true"
        @selected="onDateFromSelected"
      />
    </div>

    <div class="d-flex align-items-center date-range-picker--date-cell">
      <label class="me-3">До:</label>
      <datepicker
        :value="dateTo"
        :language="RU"
        :disabled-dates="disabledDatesForTo"
        :format="format"
        :clear-button="true"
        :monday-first="true"
        @selected="onDateToSelected"
      />
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { ru } from '@/locale';
import { format } from 'date-fns';

export default {
  name: 'BlogDateRanges',
  components: {
    Datepicker,
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
    };
  },
  computed: {
    format() {
      return 'dd.MM.yyyy';
    },
    disabledDatesForFrom() {
      // если выбрана dateTo — запрещаем выбирать после неё
      return this.dateTo
        ? {
            from: this.dateTo,
          }
        : {};
    },
    disabledDatesForTo() {
      // если выбрана dateFrom — запрещаем выбирать до неё
      return this.dateFrom
        ? {
            to: this.dateFrom,
          }
        : {};
    },
    RU() {
      return ru;
    },
  },
  created() {
    try {
      if (this.$route.query.date_from)
        this.dateFrom = new Date(this.$route.query.date_from);
    } catch (err) {
      console.error(
        'BlogDateRanges: Error on attempt to init date set-up',
        err
      );
    }

    try {
      if (this.$route.query.date_to)
        this.dateTo = new Date(this.$route.query.date_to);
    } catch (err) {
      console.error(
        'BlogDateRanges: Error on attempt to init date set-up',
        err
      );
    }
  },
  methods: {
    onDateFromSelected(date) {
      this.dateFrom = date;
      if (this.dateFrom != null && this.dateTo < date) {
        this.dateTo = null;
      }
      this.emitRange();
    },
    onDateToSelected(date) {
      this.dateTo = date;
      if (this.dateTo != null && this.dateFrom > date) {
        this.dateFrom = null;
      }
      this.emitRange();
    },
    emitRange() {
      const params = {};
      if (this.dateFrom) {
        params.date_from = format(this.dateFrom, 'YYYY-MM-DD HH:mm:ss');
      } else {
        params.date_from = undefined;
      }

      if (this.dateTo) {
        params.date_to = format(this.dateTo, 'YYYY-MM-DD HH:mm:ss');
      } else {
        params.date_to = undefined;
      }

      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          page: 1,
          ...params,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.date-range-picker {
  display: flex;
  gap: 1rem;

  &--date-cell {
    height: 100%;
    align-items: center;
  }
}

/* Input как кнопка-фильтр */
/deep/ .vdp-datepicker input {
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  min-width: 120px;
}

/deep/ .vdp-datepicker input:focus {
  border-color: #4caf50;
}

.date-range-picker >>> .vdp-datepicker__calendar {
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: white;
  font-family: sans-serif;
  padding: 8px;
  margin-top: 0.5rem;
}

.date-range-picker >>> .day__month_btn {
  font-weight: normal;
  font-size: 1rem;
  padding: 4px 8px;
  color: #333;
  border-radius: 6px;
}

.date-range-picker >>> .prev,
.date-range-picker >>> .next {
  font-size: 18px;
  padding: 6px;
  cursor: pointer;
  color: #4caf50;
  border-radius: 6px;
}

.date-range-picker >>> .prev:after {
  border-right: 10px solid #4caf50;
}

.date-range-picker >>> .next:after {
  border-left: 10px solid #4caf50;
}

.date-range-picker >>> .cell.day:hover {
  background-color: #e8f5e9;
  border-radius: 4px;
}
.date-range-picker >>> .cell.selected.day:hover,
.date-range-picker >>> .cell.selected {
  background-color: #4caf50;
  color: white;
  border-radius: 4px;
}

.date-range-picker >>> .vdp-datepicker__clear-button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 13px;
}

.date-range-picker >>> .day-header {
  font-weight: normal;
  color: #666;
  font-size: 13px;
  padding-bottom: 4px;
}

.date-range-picker >>> .cell.today {
  border: 1px solid #4caf50;
}

.date-range-picker >>> .cell {
  border-radius: 6px;
}

.date-range-picker >>> .cell.disabled {
  color: #ccc;
  background: rgba(102, 102, 102, 0.1);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// BlogDateRanges.vue?adaa3df6